// Key Codes
export const ENTER_KEY = 'Enter';
